import useFeatureToggle from './useFeatureToggle';

const FeatureToggle = ({ children, name }) => {
  const featureToggle = useFeatureToggle(name);
  if (featureToggle) {
    return children;
  }
  return null;
};

export default FeatureToggle;
